import { Link } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { StoreContext } from '../context/store-context';
import { breakpoints } from '../utils/helpers';
import Star from '-!svg-react-loader!../assets/images/full-star.svg';
import Wishlist from '-!svg-react-loader!../assets/images/wishlist.svg';
import Image from '../components/image';
import AddToCartForm from './add-to-cart-form';
import Next from '-!svg-react-loader!../assets/images/slide-arrow-next.svg';
import Prev from '-!svg-react-loader!../assets/images/slide-arrow-prev.svg';
import { StaticImage } from 'gatsby-plugin-image';
import ProductContactButton from './product-contact-button';

const ViewedProducts = () => {
  const { viewedProducts } = useContext(StoreContext);
  const [swiper, setSwiper] = useState(null);

  const [wish, setWish] = useState(false)
  const {
      toggleWish,
      wishList
  } = useContext(StoreContext);

  useEffect(() => {
      wishList.forEach(el => {
          if (el === viewedProducts.shopifyId) {
              setWish(true)
          }
      });
  }, [wishList,toggleWish, viewedProducts.shopifyId])

  const handleWish = ()=> {
      toggleWish(viewedProducts.shopifyId)
      setWish(!wish)
  }

  const adjustHeight = () => {
    let maxHeight = 0;
    document.querySelectorAll('.swiper-slide .Product').forEach(slide => {
      const height = slide.offsetHeight;
      maxHeight = height > maxHeight ? height : maxHeight;
    });
    document.querySelectorAll('.swiper-slide').forEach(slide => {
      slide.style.height = `${maxHeight}px`;
    });
  };

  useEffect(() => {
    adjustHeight();
    window.addEventListener('resize', adjustHeight);
    return () => {
      window.removeEventListener('resize', adjustHeight);
    };
  }, [viewedProducts]);

  if(viewedProducts.length <= 0) {
    return false
  } else {
    return (
      <div className="Container">
        <div className='Collection__previously__hr'></div>
        <h2 className="Collection__previously__title script">
          Previously Viewed
        </h2>

        <div className="Collection__previously__inner">
          <button
            className='Nav__button next'
            aria-label='next'
            onClick={() => swiper.slideNext()}
          >
            <Next />
          </button>
          <button
            className='Nav__button prev'
            aria-label='prev'
            onClick={() => swiper.slidePrev()}
          >
            <Prev />
          </button>
          <Swiper
            observer={true}
            observeParents={true}
            autoHeight={true}
            className="Collection__previously__list"
            spaceBetween={41}
            onSwiper={setSwiper}
            navigation={{
              nextEl: '.Collection__previously__inner .Nav__button.next',
              prevEl: '.Collection__previously__inner .Nav__button.prev',
            }}
            breakpoints={{
              [breakpoints.sm]: {
                slidesPerView: 1,
              },
              [breakpoints.md]: {
                slidesPerView: 3,
              },
              [breakpoints.xl]: {
                slidesPerView: 5,
              },
            }}
          >
            {viewedProducts.map((product, index) => (
              <SwiperSlide key={index}>
                  <div className='Product' data-id={product.shopifyId}>
                    <div className="Product__thumbnail">
                        <Link to={`/product/${product.handle}`} className='Product__thumbnail__link'>
                          {product.featuredImage ? (
                            <Image source={product.featuredImage.originalSrc} imgClass="Product__thumbnail__img" />
                          ) : (
                            <StaticImage
                              src="../assets/images/scroll-logo.png"
                              className="Product__thumbnail__img Product__thumbnail__img--missing"
                              alt={'product thumbnail'}
                            />
                          )}
                        </Link>

                        <div className="Product__wishlist">
                            <Wishlist onClick={handleWish} className={`${wish ? 'wished' : ''}`} />
                        </div>
                    </div>

                    {product.vendor && product.vendor !== 'vendor-unknown' && (
                        <small className='Product__brand'>{product.vendor}</small>
                    )}

                    <Link to={`/product/${product.handle}`} className='Product__name'>{product.title} </Link>

                    <div className="Product__rating">
                        <Star />
                    </div>
                    {product?.metafields.find(metafield => metafield.namespace === 'hiding' && metafield.key === 'hidingAddToCart' && metafield.value === 'true') ? (
                      <ProductContactButton product={product} page={true} metafields={product?.metafields} />
                    ) : (
                      <AddToCartForm product={product} productPage={true} />
                    )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    )
  }
}

export default ViewedProducts;
